module.exports = __webpack_public_path__ + "img/FR11470.c8ac425e.png";